import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2, Inject, Optional, OnInit } from '@angular/core';
import { createElement } from '@angular/core/src/view/element';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';


@Directive({
    selector: '[appCharLimit]'
})
export class LimitCharactersDirective implements AfterViewInit, OnInit {
    @Input() appCharLimit: number;
    private effectiveLimit = 8000;
    private counterElement: HTMLElement | null = null;
    private controlSub: Subscription | null = null;
    private lastRowCount = 0;
    constructor(
        private el: ElementRef<HTMLTextAreaElement | HTMLInputElement>,
        private renderer: Renderer2,
        //@Optional() @Inject(CHAR_LIMIT_CONFIG) private config?: CharLimitConfig
        @Optional() private ngControl?: NgControl
    ) { }

    ngOnInit() {
        if (this.appCharLimit === null) { this.ngOnDestroy(); return; };
        const fromInput = this.normalizeInput(this.appCharLimit);
        console.log(fromInput + '' + this.appCharLimit);
        this.effectiveLimit = (fromInput !== null && fromInput !== undefined)
            ? fromInput
            : ((this.appCharLimit && this.appCharLimit !== null)
                ? this.appCharLimit
                : 8000);
    }

    ngAfterViewInit(): void {
        if (this.appCharLimit === null) { this.ngOnDestroy(); return; };
        const host = this.el.nativeElement;
        if (host instanceof HTMLTextAreaElement || host instanceof HTMLInputElement) {
            this.renderer.setAttribute(host, 'maxlength', String(this.effectiveLimit));
        }

        this.counterElement = this.renderer.createElement('div');
        if (this.effectiveLimit > 249) {
            this.renderer.addClass(this.counterElement, 'char-counter');
        }
        else {
            this.renderer.addClass(this.counterElement, 'char-counter-input');
        }
        
        //Attach counter right after the host element
        const parent = host.parentElement || host;
        const ref = host.nextSibling as Node | null;
        try {
            this.renderer.insertBefore(parent, this.counterElement, ref);
        }
        catch {
            this.renderer.appendChild(parent, this.counterElement);
        }
        this.renderer.setStyle(this.counterElement, 'display', 'block');

        //Ensure intial value is reflected.Some bindings set the value after 
        //ngAfterViewInit, so do an immediate update and a microtask re-check.

        this.updateCounter();
        setTimeout(() => this.updateCounter(), 0);

        //Subscribe to form control value changes if present

        if (this.ngControl && this.ngControl.valueChanges) {
            this.controlSub = this.ngControl.valueChanges.subscribe(() => this.updateCounter());
        }

    }

    @HostListener('input') onInput() {
         if (this.appCharLimit === null) { this.ngOnDestroy(); return; };
        const host = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement;
        if (!host) return;
        const value = host.value || '';
        if (value.length > this.effectiveLimit) {
            const pos = (host.selectionStart !== null && host.selectionStart !== undefined)
                ? host.selectionStart
                : this.effectiveLimit;
            host.value = value.slice(0, this.effectiveLimit);
            const caret = Math.min(pos, this.effectiveLimit);
            host.setSelectionRange(caret, caret);
           
        }
        this.insertNewlineWhenRowsAtLeast(3);
        this.updateCounter();
        //this.adjustHostHeight();
      
    }

    @HostListener('paste', ['$event']) onPaste(e: ClipboardEvent) {
        if (this.appCharLimit === null) { this.ngOnDestroy(); return; };
        const pasted = (e.clipboardData && (e.clipboardData.getData ? e.clipboardData.getData('text') : '')) || '';
        const host = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement;
        const allowed = this.effectiveLimit - ((host.value && host.value.length) || 0);
        if (allowed <= 0) {
            e.preventDefault();
            return;
        }
        if (pasted.length > allowed) {
            e.preventDefault();
            const start = (host.selectionStart !== null && host.selectionStart !== undefined)
                ? host.selectionStart
                : host.value.length;
            const end = (host.selectionEnd !== null && host.selectionStart !== undefined)
                ? host.selectionEnd
                : start;
            const toInsert = pasted.slice(0, allowed);
            const newVal = host.value.slice(0, start) + toInsert + host.value.slice(end);
            host.value = newVal.slice(0, this.effectiveLimit);
            const caret = start + toInsert.length;
            host.setSelectionRange(caret, caret);
            this.insertNewlineWhenRowsAtLeast(3);
            this.updateCounter();
           // this.adjustHostHeight();
        }

    }

    private updateCounter():void {

        //if (!this.counterElement) return;
        //const len = ((this.el.nativeElement && this.el.nativeElement.value) || '').length;
        //this.counterElement.textContent = `${len}/${this.effectiveLimit}`;
        if (!this.counterElement) return;
        const target = (this.el && this.el.nativeElement) as HTMLTextAreaElement | HTMLInputElement | undefined;
        const len = ((target && target.value) || '').length;
        const host = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement;
        if (len >= this.effectiveLimit) {
            try { this.renderer.addClass(host, 'char-limit-error'); } catch { }
        }
        else {
            try { this.renderer.removeClass(host, 'char-limit-error'); } catch { }
        }
         this.counterElement.textContent = `${len}/${this.effectiveLimit}`;
       // this.adjustHostHeight();
    }

    ngOnDestroy(): void {
        try { this.controlSub && this.controlSub.unsubscribe(); } catch { }
        this.controlSub = null;
        if (this.counterElement && this.counterElement.parentNode) {
            try {
                this.counterElement.parentNode.removeChild(this.counterElement);
                const host = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement;
                this.renderer.removeClass(host, 'char-limit-error');
            } catch { }
        }
    }

    private normalizeInput(value?: number | string): number | undefined {
        if (value == null) return undefined;
        if (typeof value === 'number') return value;
        const trimmed = String(value).trim();
        if (trimmed === '') return undefined;
        const n = parseInt(trimmed, 10);
        return Number.isFinite(n) ? n : undefined;
    }

    private adjustHostHeight(): void {
        const host = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement | undefined;
        if (!host) return;
        //Only auto-resize textareas
        if ((host as HTMLElement).tagName !== 'TEXTAREA') return;
        try {
            this.renderer.setStyle(host, 'height', 'auto');
            const textarea = host as HTMLTextAreaElement;
            const scroll = textarea.scrollHeight;
           
            // add a small extra to avoid clipping
            //this.renderer.setStyle(host, 'height', '${scroll + 10}px');

            //determine line-height (fallback to 20px) and compute rows
            const doc = (textarea as HTMLElement).ownerDocument;
            const win = (doc && (doc.defaultView as Window)) || (typeof window !== 'undefined' ? window : undefined as any);
            const cs = win && win.getComputedStyle ? win.getComputedStyle(textarea) : null;
            let lineHeight = cs ? parseFloat(cs.lineHeight || '0') : 0;
            if (!Number.isFinite(lineHeight) || lineHeight <= 0) lineHeight = 20;
            const rows = Math.floor(scroll / lineHeight);
            //if user content reaches 3 rows, add one extra row height;otherwise add small buffer
            const extra = rows >= 3 ? lineHeight : 10;
            textarea.style.height = "auto";
            this.renderer.setStyle(host, 'height', (scroll + extra) + 'px');
            textarea.style.height = `${textarea.scrollHeight}px`
            textarea.style.height = textarea.scrollHeight + 'px';
            //host.style.height = "${scroll + extra}px";
        }
        catch {}
    }

    private insertNewlineWhenRowsAtLeast(minRows: number): void {
        const host = this.el.nativeElement as HTMLTextAreaElement | HTMLInputElement | undefined;
        if (!host) return;
        //Only auto-resize textareas
        if ((host as HTMLElement).tagName !== 'TEXTAREA') return;
        try {
            this.renderer.setStyle(host, 'height', 'auto');
            const textarea = host as HTMLTextAreaElement;
            const scroll = textarea.scrollHeight;

            // add a small extra to avoid clipping
            //this.renderer.setStyle(host, 'height', '${scroll + 10}px');

            //determine line-height (fallback to 20px) and compute rows
            const doc = (textarea as HTMLElement).ownerDocument;
            const win = (doc && (doc.defaultView as Window)) || (typeof window !== 'undefined' ? window : undefined as any);
            const cs = win && win.getComputedStyle ? win.getComputedStyle(textarea) : null;
            let lineHeight = cs ? parseFloat(cs.lineHeight || '0') : 0;
            if (!Number.isFinite(lineHeight) || lineHeight <= 0) lineHeight = 20;
            const rows = Math.floor(scroll / lineHeight);
            //only act when rows transition from below minRows to >= minRows
            if (this.lastRowCount < minRows && rows >= minRows) {
                const val = textarea.value || '';
                const start = (textarea.selectionStart !== null && textarea.selectionStart !== undefined) ? textarea.selectionStart : val.length;
                const end = (textarea.selectionEnd !== null && textarea.selectionEnd !== undefined) ? textarea.selectionEnd : start;
                //if there's already a newline at or immediately after start, do nothing
                if (val[start] === '\n' || val[end] === '\n') {
                    this.lastRowCount = rows;
                    return;
                }
                if (this.lastRowCount > 0) {
                    const newVal = val.slice(0, start) + '\n' + val.slice(end);
                    textarea.value = newVal;
                    const newCaret = start + 1;
                    try {
                        textarea.setSelectionRange(newCaret, newCaret);
                    } catch { }
                }
             
               
                //update row count to reflect insertion
                this.lastRowCount = Math.floor(textarea.scrollHeight / lineHeight);
                return;
            }
            this.lastRowCount = rows;
        }
        catch { }
    }

}

